/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RewardOrigin = {
    SPIN_TO_WIN: 'SPIN_TO_WIN',
    TICKET_SCAN: 'TICKET_SCAN',
    API: 'API',
    unknown_default_open_api: '11184809'
} as const;
export type RewardOrigin = typeof RewardOrigin[keyof typeof RewardOrigin];


export function instanceOfRewardOrigin(value: any): boolean {
    for (const key in RewardOrigin) {
        if (Object.prototype.hasOwnProperty.call(RewardOrigin, key)) {
            if (RewardOrigin[key as keyof typeof RewardOrigin] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RewardOriginFromJSON(json: any): RewardOrigin {
    return RewardOriginFromJSONTyped(json, false);
}

export function RewardOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardOrigin {
    return json as RewardOrigin;
}

export function RewardOriginToJSON(value?: RewardOrigin | null): any {
    return value as any;
}

